/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoaderNew from "../components/LoaderNew";
import SuccessModal from "../components/SuccessModal";
import FailureModal from "../components/FailureModal";
import { clog, setRedirectAfterLogin } from "../lib/utils";

function DynamicPage() {
  const navigate = useNavigate();
  const { type, type_id, request_id } = useParams();
  const [successModal, setSuccessModal] = useState(false);
  const [failureModal, setFailureModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const acceptInvitation = async () => {
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/user/invite/accept`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: {
          req_uniq_id: request_id,
          type: type,
        },
      });
      console.log(response, "response");
      if (!response.data.error) {
        // set selected workspace in local storage
        if (response?.data?.workspace != null) {
          clog(response?.data?.workspace, "workspace from invite");
          localStorage.setItem(
            "selected_workspace",
            JSON.stringify(response?.data)
          );
        }
        // Show success message
        setModalMessage("Invitation accepted successfully!");
        setSuccessModal(true);
        
        // Navigate after 3 seconds
        setTimeout(() => {
          navigate("/script");
        }, 3000);
      } else {
        // Show error message
        setModalMessage(response.data.message || "Failed to accept invitation");
        setFailureModal(true);
        
        // Navigate after 5 seconds
        setTimeout(() => {
          navigate("/script");
        }, 5000);
      }
    } catch (error) {
      if (error && error.response.status === 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      console.log(error);
    }
  };
  useEffect(() => {
    if (!localStorage.getItem("login_token")) {
      // Store redirect info in localStorage for persistence using utility function
      setRedirectAfterLogin({
        from: "dynamic_page",
        url: `workspace/${type}/${type_id}/${request_id}`,
      });

      navigate("/", {
        state: {
          from: "dynamic_page",
          url: `workspace/${type}/${type_id}/${request_id}`,
        },
      });
    } else {
      acceptInvitation();
      // console.log("I am came back");
    }
  }, []);

  return (
    <>
      <LoaderNew from="dynamic_page" />
      <SuccessModal
        open={successModal ? "dismissible" : ""}
        removeModal={() => {
          setSuccessModal(false);
          navigate("/script");
        }}
        successFailureMessage={modalMessage}
      />
      <FailureModal
        open={failureModal ? "dismissible" : ""}
        removeModal={() => {
          setFailureModal(false);
          navigate("/script");
        }}
        successFailureMessage={modalMessage}
      />
    </>
  );
}

export default DynamicPage;
